import React from 'react'
import { connect } from 'react-redux'
import '../../../../styles/scss/components/equote-search-filter-buttons.scss'
import { getBrandsData } from '../../../../sessionStorage/getBrandsData'
import CustomSelect from '../../../elements/CustomSelect'

import {
  VOYAGE_TYPES,
  VOYAGE_TYPE,
  BRAND_NARROW_RESUTLS
} from '../../../../configuration/filters'

function renderCruiseTourTypeOptions(cruiseTours) {
  if (!cruiseTours || !cruiseTours.length) return []
  const options = new Set()
  cruiseTours.forEach(cruiseTour => {
    options.add(cruiseTour.tourTypeLabel)
  })
  return [...options.values()]
}

const EQuoteSailingsFullSearchFilterButtons = ({
  activeSailingsTab,
  packages,
  cruiseTours,
  landPrograms,
  activeSearchFilterData,
  filters,
  handleFilterChangeTerm
}) => {
  const filterDuplicatesValues = (array, key) => {
    return array.reduce((filtered, item) => {
      if (!filtered.find(f => f[key] === item[key])) {
        filtered.push(item)
      }
      return filtered
    }, [])
  }
  const sortNumber = (a, b) => {
    return a - b
  }

  const getBrandValue = (filter, activeBrand, enabledBrands) => {
    if (filter) return filter
    if (enabledBrands.length === 1) return enabledBrands[0].value

    return activeBrand
  }

  //Switch array of sailings based on options "Cruises" / "Tours"
  const sailingOption =
    activeSailingsTab === 0
      ? packages
      : activeSailingsTab === 1
      ? cruiseTours
      : landPrograms

  // SENARIO FILTER OPTIONS START

  const voyageTypes = VOYAGE_TYPES.filter(item =>
    item.brands.includes(activeSearchFilterData.brand)
  )

  const filteredBrands = BRAND_NARROW_RESUTLS.map(brand => {
    return {
      label: brand.label,
      value: brand.brand,
      disabled:
        filters.voyageType && filters.voyageType !== ''
          ? !brand.types.includes(filters.voyageType)
          : false
    }
  })

  const enabledBrands = filteredBrands.filter(brand => !brand.disabled)
  let filteredShips = sailingOption

  if (filters.voyageType && filters.voyageType !== 'O,V') {
    filteredShips = filteredShips.filter(
      item => item.voyageType === VOYAGE_TYPE[filters.voyageType]
    )
  }

  if (
    (filters.brand && filters.brand !== 'C,R') ||
    enabledBrands.length === 1
  ) {
    const brandFilter = filters.brand ?? enabledBrands[0].value
    filteredShips = filteredShips.filter(item => item.brand === brandFilter)
  }

  // SENARIO FILTER OPTIONS END
  const brands = filteredBrands
  const ships = filterDuplicatesValues(filteredShips, 'shipName')
  const destinations = filterDuplicatesValues(
    filteredShips,
    'destinationName'
  ).sort()
  const nights = filterDuplicatesValues(filteredShips, 'totalNights').sort(
    sortNumber
  )

  const landProgramTypes =
    activeSailingsTab === 2 && landPrograms && landPrograms.length
      ? filterDuplicatesValues(landPrograms, 'landProgramType')
      : []

  const cruiseTourTypes =
    activeSailingsTab === 1 && cruiseTours && cruiseTours.length
      ? renderCruiseTourTypeOptions(cruiseTours)
      : []

  return (
    <div
      className="equote__sailings-full-search-filter"
      key={activeSailingsTab}
    >
      <h6 className="equote__sailings-full-search-filter-title">
        Narrow Your Results
      </h6>

      <div className="equote__sailings-full-search-filter-buttons">
        {voyageTypes.length > 1 && (
          <CustomSelect
            name="voyageType"
            value={filters.voyageType || 'O,V'}
            onChange={handleFilterChangeTerm}
            options={voyageTypes.map(
              type =>
                type && {
                  value: type.filter,
                  text: type.label
                }
            )}
          />
        )}

        <CustomSelect
          name="brand"
          value={getBrandValue(
            filters.brand,
            activeSearchFilterData.brand,
            enabledBrands
          )}
          onChange={handleFilterChangeTerm}
          defaultOption={{
            value: 'C,R',
            text: 'All Brands',
            disabled: enabledBrands.length === 1 ?? false
          }}
          options={brands.sort().map(
            brand =>
              brand && {
                value: brand.value,
                text: brand.label,
                disabled: brand.disabled
              }
          )}
        />

        <CustomSelect
          name="ship"
          value={filters.ship || ''}
          onChange={handleFilterChangeTerm}
          defaultOption={{
            value: '',
            text: 'All Ships'
          }}
          options={ships.sort().map(
            ship =>
              ship && {
                value: ship.shipCode,
                text: ship.shipName
              }
          )}
        />

        <CustomSelect
          name="destination"
          value={filters.destination || ''}
          onChange={handleFilterChangeTerm}
          defaultOption={{
            value: '',
            text: 'All Destinations'
          }}
          options={destinations.sort().map(
            destination =>
              destination && {
                value: destination.destinationCode,
                text: destination.destinationName
              }
          )}
        />

        <CustomSelect
          name="nights"
          value={filters.nights || ''}
          onChange={handleFilterChangeTerm}
          defaultOption={{
            value: '',
            text: 'All Nights'
          }}
          options={nights
            .filter(night => !!night)
            .sort((a, b) => +a - +b)
            .map(night => ({
              value: night.totalNights,
              text: `${night.totalNights} night${
                night.totalNights > 1 ? 's' : ''
              }`
            }))}
        />

        {Boolean(landProgramTypes && landProgramTypes.length) && (
          <CustomSelect
            name="landProgramTypes"
            onChange={handleFilterChangeTerm}
            defaultOption={{
              value: '',
              text: 'Pre and Post Land Programs'
            }}
            options={landProgramTypes.map(tourType => ({
              value: tourType,
              text: `${tourType.charAt(0).toUpperCase() +
                tourType.slice(1)} Land Program`
            }))}
          />
        )}
        {Boolean(cruiseTourTypes && cruiseTourTypes.length) && (
          <CustomSelect
            name="tourTypeLabel"
            onChange={handleFilterChangeTerm}
            defaultOption={{
              value: '',
              text: 'All Tour Types'
            }}
            options={cruiseTourTypes.map(tourType => ({
              value: tourType,
              text: `${tourType === 'BOTH' ? 'PRE/POST' : tourType} Tour`
            }))}
          />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  activeSearchFilterData: state.activeSearchFilterData,
  brandsData: getBrandsData()
})

export default connect(mapStateToProps)(EQuoteSailingsFullSearchFilterButtons)
